var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%"}},[_c('div',[_c('img',{staticStyle:{"display":"block","margin":"100px auto"},attrs:{"src":_vm.errGif,"alt":"Girl has dropped her ice cream."}})])])}
var staticRenderFns = []

export { render, staticRenderFns }